import { OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
var SearchHeaderItemAmountComponent = /** @class */ (function () {
    function SearchHeaderItemAmountComponent(translate) {
        if (translate === void 0) { translate = null; }
        this.translate = translate;
    }
    Object.defineProperty(SearchHeaderItemAmountComponent.prototype, "itemCountDescription", {
        get: function () {
            if (this.itemCount > 1)
                return this.translate.instant('multiItemFounds.TITLE');
            else
                return this.translate.instant('singleItemFound.TITLE');
        },
        enumerable: true,
        configurable: true
    });
    SearchHeaderItemAmountComponent.prototype.ngOnInit = function () {
    };
    return SearchHeaderItemAmountComponent;
}());
export { SearchHeaderItemAmountComponent };
